import { render, staticRenderFns } from "./GroupInputBox.vue?vue&type=template&id=b2ad8648"
import script from "./GroupInputBox.vue?vue&type=script&lang=js"
export * from "./GroupInputBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports